import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Login from './pages/Login';
import ScanVideo from './pages/ScanVideo'
import ScanHistory from './pages/ScanHistroy'
import SideBar from './components/SideBar';
import ProtectedRoute from './routes/ProtectedRoute';
import Scan from './pages/scans/Scan'

const AppRoutes = () => {
  const location = useLocation();
  const isLoginRoute = location.pathname === '/';

  return (
    <>
      {isLoginRoute ? (
        <Routes>
          <Route path="/" element={<Login />} />
        </Routes>
      ) : (
        <SideBar>
          <Routes>
            <Route path="/scan" element={<ProtectedRoute><Scan /></ProtectedRoute>} />
            <Route path="/scan_history" element={<ProtectedRoute><ScanHistory /></ProtectedRoute>} />
            <Route path="/scan_video" element={<ProtectedRoute><ScanVideo /></ProtectedRoute>} />
            <Route path="*" element={<>Not Found</>} />
          </Routes>
        </SideBar>
      )}
    </>
  );
};

const App = () => (
  <Router>
    <ToastContainer />
    <AppRoutes />
  </Router>
);

export default App;
